module.exports = __webpack_public_path__ + "8a5356e9/img/search-filter-icon.c4751a52.svg";